import React from "react";
import * as Animate from "react-reveal";
import PeopleImg from "../../../assets/images/png/about.webp";

const CompanyStorySection = () => {
  return (
    <section className="py-24 lg:py-32 about-brief-section">
      <div className="container mx-auto px-4">
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-14 lg:gap-20">
          <div className="">
            <Animate.Fade bottom>
              <h4 className="text-3xl lg:text-4xl xl:text-5xl text-primary font-mono font-semibold text-center md:text-left w-10/12 md:w-9/12 mx-auto md:mx-0">
                Help Us Build Something Big.
              </h4>
              <div className="md:hidden pt-12 pb-6">
                <img src={PeopleImg} width="100%" className="" alt="" />
              </div>
              <p className="w-full text-default pt-12 pb-6 leading-8 lg:w-10/12">
                Our world today is moving with companies adopting new
                technologies to drive and accelerate high-impact growth.
                However, it does look like there is a talent gap. Companies
                struggle to find the right talents and also struggle with the
                continuous development of these tech talents.
                <br /> <br />
                Joining the Utiva Business Network is of great value to your
                organization. The network gives you a single platform to
                continue to train your staff members in selected areas of
                technology for free through our well designed and stacked
                masterclasses.
              </p>
            </Animate.Fade>
          </div>

          <div className="hidden md:block">
            <Animate.Zoom>
              <img src={PeopleImg} width="90%" className="" alt="" />
            </Animate.Zoom>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
